import { createContext, useContext, useEffect, useCallback } from "react";
import api from "@/lib/api";

const ThemeContext = createContext(null);
const STORAGE_KEY = "miledeep-theme";

// Help Desk now ships a single Quantira (Camaroo Analytics) visual system.
// Legacy stored values (midnight / light / classic / dark) all resolve to it.
export const THEMES = [
  { key: "erp", label: "Quantira Light", hint: "Camaroo Analytics design system" },
];
export const THEME_KEYS = THEMES.map((t) => t.key);
const THEME = "erp";

function applyTheme() {
  const root = document.documentElement;
  ["midnight", "light", "classic"].forEach((k) => {
    document.body.classList.remove(k);
    root.classList.remove(k);
  });
  document.body.classList.add(THEME);
  root.classList.add(THEME);
  root.style.colorScheme = "light";
}

export function ThemeProvider({ children, user }) {
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, THEME);
    applyTheme();
  }, []);

  const setTheme = useCallback(async () => {
    if (user) {
      try { await api.patch("/profile", { theme: THEME }); } catch (_e) { /* ignore */ }
    }
  }, [user]);

  return (
    <ThemeContext.Provider value={{ theme: THEME, setTheme, cycle: setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
